import React, { Component } from 'react';
import { Input, Button, Form, message } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import styles from './style.less';
import { get, post } from '../../commons/http';
import { publicEncrypt } from 'crypto';
import { connect } from 'react-redux';
import { updateUserInfo } from '../../store/user/action';
import GISBg from '../../components/gis-bg';
import supermapLogo from '../../assets/logos/supermap.png';
import hautLogo from '../../assets/logos/haut.png';

class Login extends Component {
  state = {
    loading: false,
    publicKey: '',
  };

  componentDidMount() {
    //获取公钥
    const getPublicKey = async () => {
      const response = await get('/user/key');
      const { data } = response;
      this.setState({ publicKey: data.key });
      window.localStorage.setItem('publicKey', data.key);
    };
    getPublicKey();
  }

  handleSubmit = async (values) => {
    if (this.state.loading) return;

    const { email, password } = values;

    const rsaPassword = publicEncrypt(
      this.state.publicKey,
      Buffer.from(password)
    ).toString('base64');
    const response = await post('/user/login', {
      email,
      password: rsaPassword,
    });
    const { code, msg, data } = response;
    if (code === 0) {
      window.localStorage.setItem('token', data.token);
      const user = {
        id: data.id,
        name: data.name,
        role: data.role,
        email: data.email,
        staffId: data.staffId,
      };
      this.props.updateUser(user);
      message.success('登录成功，正在跳转...', 1);
      setTimeout(() => {
        this.props.history.replace('/home/competition/all');
      }, 1000);
    } else {
      message.error(msg || '登录失败，请重试', 2);
    }
  };

  render() {
    const { loading } = this.state;

    return (
      <div className={styles.root}>
        <GISBg />
        <div className={styles['login-card']}>
          <div className={styles['logo-row']}>
            <img
              src={supermapLogo}
              alt="超图"
              className={styles['logo-supermap']}
            />
            <span className={styles['logo-divider']} />
            <img
              src={hautLogo}
              alt="河南工业大学"
              className={styles['logo-haut']}
            />
          </div>
          <div className={styles.title}>超图杯 · 河南工业大学校赛报名系统</div>
          <div className={styles.subtitle}>欢迎登录</div>
          <Form name="login" onFinish={this.handleSubmit} size="large">
            <Form.Item
              name="email"
              rules={[
                { required: true, message: '请输入邮箱' },
                { type: 'email', message: '请输入正确的邮箱地址' },
              ]}
            >
              <Input
                allowClear
                autoFocus
                prefix={<UserOutlined />}
                placeholder="邮箱"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入密码' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="密码"
              />
            </Form.Item>
            <Form.Item style={{ marginBottom: 8 }}>
              <Button
                className={styles['submit-btn']}
                loading={loading}
                type="primary"
                htmlType="submit"
                block
              >
                登录
              </Button>
            </Form.Item>
          </Form>
          <div className={styles.links}>
            <Link to="/resetPwd">忘记密码</Link>
            <span>
              没有账号？
              <Link to="/register">马上注册</Link>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => {
    const { userInfo } = state;
    return { userInfo };
  },
  (dispatch) => {
    return {
      updateUser: (data) => {
        dispatch(updateUserInfo(data));
      },
    };
  }
)(Login);